/**
 * Local storage key
 */
export enum LocalStorageKey {
  ThemeMode = 'theme-mode',
  RapiDoc = 'rapidoc',
  FcmDeviceId = 'fcm-device-id',

  // Login Quick Access
  LoginQuickAccessAvailable = 'login-quick-access-available',
  LoginQuickAccessEnabled = 'login-quick-access-enabled',
  LoginQuickAccessData = 'login-quick-access-data',
  LoginQuickAccessUserData = 'login-quick-access-user-data',

  // Seniors Pages
  SeniorsListDisplay = 'seniors-list-display',

  // Selected affiliation and relationship
  SelectedAffiliationId = 'SELECTED_AFFILIATION_ID',
  SelectedRelationshipId = 'SELECTED_RELATIONSHIP_ID',

  // Occurrence view
  OccurrencesRange = 'occurrences-range',

  // Calendar view
  CalendarRange = 'calendar-range',
  CalendarDisplay = 'calendar-display',

  // General Entity Charts view
  EntityGeneralChartsRange = 'entity-general-charts-range',

  // (Senior)General Stats Charts view
  GeneralChartsRange = 'general-charts-range',

  // (Senior)Health Stats Charts view
  HealthChartsRange = 'health-charts-range',

  // Care and Activities view
  CareAndActivitiesRange = 'care-and-activities-range',

  // Care Services view
  CareServicesRange = 'care-services-range',
}
